import { render } from "./ProfileStats.vue?vue&type=template&id=45fab149"
import script from "./ProfileStats.vue?vue&type=script&lang=js"
export * from "./ProfileStats.vue?vue&type=script&lang=js"
script.render = render

export default script